<template>
  <v-row >
    <div class="col-md-12 col-sm-12" id="ranks">
      <h2 class="gray_dk--text">Members</h2> 
      <v-slide-group v-model="model" v-if="members" >
        <v-slide-item v-for="item in members" :key="item.uuid">
          <v-card class="mr-2" height="185" width="150" :to="'/members/info/'+item.uuid">
            <v-card-title class="mt-5 rank-image">
              <v-avatar class="profile text-center" size="75" v-if="item.profile_image">
                <v-img alt="user" :src="item.profile_image" />
              </v-avatar>
              <v-avatar size="75" v-else :color="getProfileColor(item.display_name[0])">
                <span
                  v-if="item.display_name"
                  class="white--text text-uppercase"
                  >{{ item.display_name[0] }}{{ item.display_name[0] }}</span
                >
              </v-avatar>
            </v-card-title>

            <v-card-text class="text-center">
              <p class="total-point">{{ item.international_id }}</p>
              <p class="rank-name">
                {{ stringTrim(item.display_name) }}
              </p>
            </v-card-text>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </div>
  </v-row>
</template>


<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { filters } from "../../utility/filters";

export default {
  name: "MemberList",
  props:["members"],
  components: {},
  data: () => ({
    loading: false,   
    model: null,   
    defaultImage: require("@/assets/img/avatar.svg"),
  }),

  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },

  methods: {
     getProfileColor(letter) {
      return filters.getProfileColor(letter);
    },
    stringTrim(text) {
      return filters.stringTrim(text, 20);
    } 
  },
};
</script>
<style>
#ranks .v-card{
    box-shadow: none;
}
</style>